export const validateUUID = (value: string): boolean => {
  if (!value) {
    return true;
  }
  const pattern =
    /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;
  return pattern.test(value);
};
